import { commitMutation, graphql } from 'react-relay/legacy';
import getRelayEnvironment from '../../../../src/relayClientEnvironment';

const mutation = graphql`
    mutation completeAccountEmailMutation($input: CompleteAccountEmailInput!) {
        completeAccountEmail(input: $input) {
            message
        }
    }
`;

export function completeAccountEmailMutation({ environment = getRelayEnvironment(), email }) {
    commitMutation(environment, {
        mutation,
        variables: {
            input: { email },
        },
    });
}
